import { styled as _styled } from '@mui/material/styles';

export const customStyled = _styled;

export default customStyled;
